import {GuiUserSettings} from './../../../../_shared/model/userGuiSettings/guiUserSettings.model';
import { ContractorSettings, GuiUserContractorSettings} from '../../../../_shared/model';
import {HttpClientService} from '../../../../_shared/services/http-client.service';
import {Observable} from 'rxjs';
import {HelperService, StorageService} from '../../../../_shared/services';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ConfigGUIService {
    constructor(
        private storage: StorageService,
        private helper: HelperService,
        private httpClient: HttpClientService,
    ) {}

    public updateUserContractorGuiSettings(cid: number, guiSettings: GuiUserContractorSettings): boolean {
        let res: boolean = true;
        this.httpClient.put(this.helper.getApiUrl() + '/app/settings/' + cid, guiSettings).subscribe(
            () => {
                this.storage.setGuiUserContractorSettings(guiSettings);
                res = true;
            },
            () => {
                res = false;
            },
        );
        return res;
    }

    public getUserGuiSettings(): Observable<GuiUserSettings> {
        return this.httpClient.get(this.helper.getApiUrl(2) + `/app/settings/user`);
    }

    public getUserContractorGuiSettings(cid: number): Observable<GuiUserContractorSettings> {
        return this.httpClient.get(this.helper.getApiUrl(2) + `/app/settings/${cid}`);
    }

    public getGlobalSettings(): Observable<any> {
        return this.httpClient.get(this.helper.getApiUrl(2) + `/app/settings/`);
    }

    public getContractorGuiSettings(cid: number): Observable<ContractorSettings> {
        return this.httpClient.get(this.helper.getApiUrl(2) + `/app/settings/contractor/${cid}`);
    }
}
